const hasWindow = (function () {
    return typeof window !== 'undefined';
})();

const hasLocalStorage = (function () {
    if (!hasWindow) {
        return false;
    }
    return typeof localStorage !== 'undefined';
})();

const getRandomID = (IDLength) => {
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    for ( let i = 0; i < IDLength; i++ ) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
};

export { hasWindow, hasLocalStorage, getRandomID };
